import React from 'react';
import { Link } from 'react-router-dom';
interface CategoryCardProps {
  id: string;
  name: string;
  description: string;
  image: string;
  productCount: number;
}
const CategoryCard = ({
  id,
  name,
  description,
  image,
  productCount
}: CategoryCardProps) => {
  return <Link to={`/categories/${id}`} className="group" data-id="element-212">
      <div className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition duration-300" data-id="element-213">
        <div className="h-48 overflow-hidden" data-id="element-214">
          <img src={image} alt={name} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" data-id="element-215" />
        </div>
        <div className="p-5" data-id="element-216">
          <h3 className="text-lg font-semibold mb-2 group-hover:text-blue-600 transition duration-200" data-id="element-217">
            {name}
          </h3>
          <p className="text-gray-600 text-sm mb-3" data-id="element-218">{description}</p>
          <div className="flex justify-between items-center" data-id="element-219">
            <span className="text-sm text-gray-500" data-id="element-220">
              {productCount} products
            </span>
            <span className="text-blue-600 font-medium text-sm group-hover:underline" data-id="element-221">
              Explore →
            </span>
          </div>
        </div>
      </div>
    </Link>;
};
export default CategoryCard;